import { render, staticRenderFns } from "./T1TopRegionyThumbnails.vue?vue&type=template&id=24fd6ebb&scoped=true&"
import script from "./T1TopRegionyThumbnails.vue?vue&type=script&lang=js&"
export * from "./T1TopRegionyThumbnails.vue?vue&type=script&lang=js&"
import style0 from "./T1TopRegionyThumbnails.vue?vue&type=style&index=0&id=24fd6ebb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fd6ebb",
  null
  
)

export default component.exports